<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
      <v-text-field
        v-model="username"
        label="Nombre de usuario"
        variant="solo"
        :rules="obligatorio"
        required
      >
      </v-text-field>
      <v-btn type="submit" id="boton-verde" :loading="cargando" :disabled="!valid">Resetear</v-btn
      >
    </v-form>
    <ClosableAlert
      v-if="alert"
      :type="responseType"
      :key="alertKey"
      :texto="mensaje"
      titulo="Resetear contraseña"
    ></ClosableAlert>
</template>

<style src="../assets/general.css"></style>

<script>
import { obligatorio } from "@/_helpers/rules";
import AuthService from "@/api/AuthService";
import ClosableAlert from "./ClosableAlert.vue";

const authService = new AuthService();

export default {
  components: {
    ClosableAlert,
  },
  data() {
    return {
      valid: false,
      username: null,
      obligatorio: obligatorio,
      cargando: false,
      alert: false,
      responseType: "info",
      mensaje: "",
      alertKey: 0
    };
  },
  methods: {
    async handleSubmit() {
      this.cargando = true;
      let response = await authService.resetPassword(this.username);
      if (response.status === 200) {
        this.responseType = "success";
        this.mensaje = "Contraseña reseteada correctamente.";
      } else {
        this.responseType = "error";
        this.mensaje = response.message || response.data.message || response.data || 'Error al crear profesional';
      }
      this.alert = true;
      this.alertKey += 1;
      this.cargando = false;
    },
  },
};
</script>
